import { useState } from "react";
import { RotateCcw } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import "./resumen.css";
import "./graf.css";
import { Buscador } from "./Buscador";
import { TarjetaCliente } from "./TarjetaCliente";
import { Kpis } from "./Kpis";
import { Medidor } from "./Medidor";
import { Dona } from "./Dona";
import { Proximo } from "./Proximo";
import { AlertasExternas } from "./AlertasExternas";
import { PatrimonioBloque, ClimaLinea, TotalesTipo } from "@/components/dashboard/Inmuebles";
import { ZafraTotal } from "@/components/dashboard/inmuebles/ZafraPanel";
import { LineaTiempo } from "./LineaTiempo";
import { Fila3 } from "./Fila3";
import { Condiciones } from "./Condiciones";
import { Terceros } from "./Terceros";
import { Tarjetas3 } from "./Tarjetas3";

export default function ResumenBuscar({ kpis, onVerCliente, onAbrirAnalisis, onAbrirInmuebles }) {
  const [sel, setSel] = useState(null);
  const [det, setDet] = useState(null);
  const [abierto, setAbierto] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [anim, setAnim] = useState(0);

  const elegir = async (c) => {
    setSel(c); setDet(null); setAbierto(false); setCargando(true);
    try { setDet((await api.get("/resumen/cliente", { params: { clave: c.cliente } })).data); }
    catch { toast.error("No se pudo cargar la tarjeta del cliente"); }
    finally { setCargando(false); }
  };
  const card = det || sel;
  const ver = abierto && det;
  const [pdfCargando, setPdfCargando] = useState(false);
  const descargarPdf = async () => {
    setPdfCargando(true);
    try {
      const r = await api.get("/resumen/cliente/pdf", { params: { clave: det.cliente }, responseType: "blob" });
      const nombre = (r.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "Resumen.pdf";
      const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = nombre; a.click(); URL.revokeObjectURL(url);
    } catch { toast.error("No se pudo generar el PDF"); }
    finally { setPdfCargando(false); }
  };

  return (
    <div className="rs-escena" data-testid="resumen-escena">
      <div className="rs-cab" key={`cab-${anim}`}>
        <div>
          <h2 className="rs-titulo">Resumen</h2>
          <p className="rs-sub">Buscá un cliente para ver su tarjeta</p>
          <Buscador onElegir={elegir} />
        </div>
        <div className="rg-der">
          <button type="button" className="rg-repetir" onClick={() => setAnim((a) => a + 1)} data-testid="resumen-repetir-animacion"><RotateCcw className="h-3.5 w-3.5" /> Repetir animación</button>
          <Kpis kpis={kpis} />
        </div>
      </div>

      {card && (
        <div key={`det-${anim}`}>
          <div className={`rs-escenario ${ver ? "abierto" : ""}`}>
            {ver && <Medidor d={det} />}
            <div className="rs-centro w-full max-w-[420px]">
              <TarjetaCliente c={card} detalle={Boolean(ver)} onClick={() => det && setAbierto((v) => !v)} />
              {cargando && <p className="text-center text-sm mt-3" style={{ color: "#8E9B8A" }}>Cargando…</p>}
              {det && !abierto && <p className="text-center text-sm mt-3" style={{ color: "#8E9B8A" }}>Tocá la tarjeta para ver el detalle</p>}
              {ver && <Proximo d={det} />}
              {ver && (
                <div className="rs-acciones">
                  <button className="rs-btn crema" onClick={() => onVerCliente(det.cliente)} data-testid="resumen-ver-detalles">Ver más detalles →</button>
                  <button className="rs-btn" onClick={descargarPdf} disabled={pdfCargando} data-testid="resumen-descargar-pdf">{pdfCargando ? "Generando…" : "Descargar PDF"}</button>
                  {det.analisis_id && onAbrirAnalisis && <button className="rs-btn verde" onClick={() => onAbrirAnalisis(det.analisis_id)} data-testid="resumen-abrir-analisis">Abrir análisis</button>}
                  <button className="rs-btn" onClick={() => setAbierto(false)} data-testid="resumen-cerrar">Cerrar</button>
                </div>
              )}
            </div>
            {ver && <div className="rs-panel-col der"><Dona d={det} /><Terceros d={det} /></div>}
            {ver && <AlertasExternas v={det.vigilancia} onChange={() => api.get("/resumen/cliente", { params: { clave: sel.cliente } }).then((r) => setDet(r.data))} />}
            {ver && det.patrimonio && <div className="rs-panel" style={{ gridColumn: "1 / -1", padding: "10px 14px" }} data-testid="resumen-patrimonio"><div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6 }}>Patrimonio inmobiliario</div><ClimaLinea inmuebles={det.patrimonio.inmuebles} /><ZafraTotal zafra={det.patrimonio.zafra} compacto /><TotalesTipo tipos={det.patrimonio.patrimonio?.tipos} /><PatrimonioBloque p={det.patrimonio} compacto /></div>}
            {ver && <LineaTiempo d={det} />}
            {ver && <Condiciones d={det} />}
            {ver && (det.chips_red?.length > 0 || det.chip_campo || (det.chip_reputacion && det.chip_reputacion !== "Sin alertas")) && <div className="rs-panel rg-sec flex flex-wrap gap-2" style={{ gridColumn: "1 / -1", padding: "10px 14px" }} data-testid="resumen-chips-riesgo">
              {det.chip_reputacion && det.chip_reputacion !== "Sin alertas" && <span data-testid="chip-reputacion" style={{ background: det.chip_reputacion === "Alta" ? "rgba(224,96,62,.18)" : det.chip_reputacion === "Baja" ? "#33402F" : "rgba(232,207,138,.2)", color: det.chip_reputacion === "Alta" ? "#F08A6C" : det.chip_reputacion === "Baja" ? "#F3F7F2" : "#E8CF8A", borderRadius: 9999, padding: "4px 10px", fontSize: 11, fontWeight: 700 }}>Reputación: {det.chip_reputacion}</span>}
              {(det.chips_red || []).map((c) => <span key={c} style={{ background: "rgba(224,96,62,.18)", color: "#F08A6C", borderRadius: 9999, padding: "4px 10px", fontSize: 11, fontWeight: 700 }}>{c}</span>)}
              {det.chip_campo && <span style={{ background: det.chip_campo === "Riesgo" ? "rgba(224,96,62,.18)" : det.chip_campo === "Atención" ? "rgba(232,207,138,.2)" : "#33402F", color: det.chip_campo === "Riesgo" ? "#F08A6C" : det.chip_campo === "Atención" ? "#E8CF8A" : "#F3F7F2", borderRadius: 9999, padding: "4px 10px", fontSize: 11, fontWeight: 700 }}>Campo: {det.chip_campo}</span>}
            </div>}
          </div>
          {ver && <Fila3 d={det} />}
          {ver && <Tarjetas3 d={det} onAbrirInmuebles={onAbrirInmuebles} />}
        </div>
      )}
    </div>
  );
}
